import React, {PropsWithChildren, ReactElement} from "react";
import "./info-block.scss"

interface InfoBlockProps extends PropsWithChildren {
    title: string | ReactElement;
    small?: boolean;
}

export const InfoBlock: React.FC<InfoBlockProps> = ({title, small, children}) => {

    return (
        <div className={"info-block" + (small ? " small" : "")}>
            <div className={"info-block-value"}>
                {children}

            </div>
            <div className={"info-block-title"}>
                {title}
            </div>
        </div>
    )
}